import { useState } from 'react';
import { ProfileListItem } from '../types';
import { EllipsisVerticalIcon, Send, Pencil } from 'lucide-react';
import { Button } from '@predoc/cow';
// import { toast } from 'sonner';
import { useNavigate } from 'react-router';
import {
  DropdownMenuTrigger,
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuContent,
  //   DropdownMenuSeparator,
} from '@predoc/cow';
import { Permission, useHasPermission } from '@/utils/roles';
import { UserRole } from '@/feature/users/constants';

export const ActionDropdown = ({ profile }: { profile: ProfileListItem }) => {
  //   const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const { hasPermission, currentUser } = useHasPermission(
    Permission.EDIT_PROFILES,
  );

  const canEditProfiles =
    hasPermission &&
    (currentUser?.role !== UserRole.MANAGER ||
      currentUser.profileAccess.some((p) => p.id === profile.id));

  const handleView = () => {
    // TODO: resend invitation api call
    navigate(`/profiles/${profile.id}`);
    // toast.error(`Invite was not sent to ${user.email}.`);
  };

  const handleEdit = () => {
    navigate(`/profiles/${profile.id}`);
  };

  return (
    <>
      <DropdownMenu open={isDropdownOpen} onOpenChange={setIsDropdownOpen}>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="focus:border-none focus:ring-0 focus:outline-none focus-visible:border-none focus-visible:ring-0 focus-visible:outline-none"
            aria-label="Profile actions"
          >
            <EllipsisVerticalIcon className="size-5" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent side="bottom" align="start">
          <DropdownMenuItem onClick={handleView}>
            <Send size="4" />
            View
          </DropdownMenuItem>
          {canEditProfiles ? (
            <DropdownMenuItem onClick={handleEdit}>
              <Pencil size="4" />
              Edit
            </DropdownMenuItem>
          ) : null}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
